// extracted by mini-css-extract-plugin
export default {"settingsForm":"drawer_settingsForm__ayLWq","dropdownLanguages":"drawer_dropdownLanguages__Y14dQ"};